<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Pagamento Duplicado (Billing)"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getPaidBillingsSameMonthTable"
  emptyMessage="Sem mais pagamentos duplicados (billing) no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
